import { createStandardAction } from 'typesafe-actions'
import { SelectionType } from 'types/SelectionType'

export interface AnswerPayload {
  selectionType: SelectionType
  clickedAnswer: string | number
  questionId: string
}

export const selectAnswer = createStandardAction('@questions/select')<
  AnswerPayload
>()
